import URLConfig from '@Config/urls/url.config';

export const UsersModuleMenu = {
  name: 'Utilisateurs',
  link: URLConfig.ADMIN.USERS.ROOT,
  level: 1,
  subMenu: [
    {
      name: 'Gestion des utilisateurs',
      link: URLConfig.ADMIN.USERS.USERS_MANAGMENT,
      level: 2,
    },
    {
      name: 'Supervision des utilisateurs',
      link: URLConfig.ADMIN.USERS.USERS_SUPERVISION,
      level: 2,
    },
    {
      name: 'Profile',
      link: URLConfig.ADMIN.USERS.PROFILE,
      level: 2,
    },
    {
      name: 'Paramètres de mot de passe',
      link: URLConfig.ADMIN.USERS.PASSWORD_SETTINGS,
      level: 2,
    },
    // {
    //   name: 'Changer de mot de passe',
    //   link: URLConfig.ADMIN.USERS.CHANGE_PASSWORD,
    // },
    {
      name: 'Options de profile',
      link: URLConfig.ADMIN.USERS.PROFILE_OPTION_MODULE,
      level: 2,
    },
    {
      name: 'Consulation fichier log',
      link: URLConfig.ADMIN.USERS.CONSULTATION_LOG_FILE,
      level: 2,
    },
    {
      name: 'Purge de fichiers',
      link: URLConfig.ADMIN.USERS.PURGE_LOG_FILE,
      level: 2,
    },
    {
      name: 'Logs des fichiers sensibles',
      link: URLConfig.ADMIN.USERS.SENSIBLE_DATA_LOG,
      level: 2,
    },
  ],
};
